import styled from 'styled-components';

export const Icon = styled.span`
  font-size: 48px;
`;
